import { BILL_AUTOMATION_STATUS } from 'src/stores/billAutomation/uploadedBills';

/**
 * What a registered bill means for the queue row that uploaded it.
 *
 * A file now goes up in three steps — ask for a URL, PUT to S3, register the key — and the last of
 * them answers with the bill itself rather than with the per-file outcome the old multipart batch
 * returned (LB-5898). The queue still reasons in outcomes, so the translation lives here, in one
 * place with its own tests, rather than being inferred at the call site.
 *
 * A bill that failed to land is not one of these: registering throws, and the caller reports that.
 * The only outcome a returned bill can carry is which bill it is, and whether the company already
 * had this file.
 */
export function toUploadResult(bill, pickedFileName) {
  var _bill$duplicateOfBill;
  // No bill is not an outcome, and must not be read as a silent success. The queue says so in
  // words; inventing an empty result here would mark the row landed with nothing behind it.
  if (!(bill !== null && bill !== void 0 && bill.billId)) return undefined;
  return {
    // The service's name for the stored document, which is what the details view renders by. It
    // falls back to what the picker called the file, so a row is never left nameless.
    fileName: bill.fileName || pickedFileName,
    billId: bill.billId,
    duplicate: bill.status === BILL_AUTOMATION_STATUS.duplicate,
    // So the queue row can link to the bill it is a copy of (LB-6016).
    duplicateOfBillId: (_bill$duplicateOfBill = bill.duplicateOfBillId) !== null && _bill$duplicateOfBill !== void 0 ? _bill$duplicateOfBill : null,
    error: null
  };
}